import { createSelector } from 'reselect'

const poll_questions_changed_selector = createSelector(
	[ state => state.poll ],
	pollState => pollState.questions.filter(question => question.status === 'changed')
)

export default poll_questions_changed_selector
